import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { Observable, ReplaySubject } from "rxjs";
import { first, map } from "rxjs/operators";

@Injectable()
export class GisClientService {
  onInitialized = new ReplaySubject<boolean>(1);

  private gApiUrl = "https://accounts.google.com/gsi/client";

  private documentRef: Document;
  // @ts-ignore
  private gsiClient?: typeof google.accounts;

  constructor(@Inject(DOCUMENT) documentRef: any) {
    this.documentRef = documentRef;

    this.init();
  }

  private init(): void {
    const scriptElem = document.createElement("script");
    scriptElem.onload = () => {
      scriptElem.remove();
      this.gsiClient = (this.documentRef.defaultView as any).google.accounts;
      this.onInitialized.next(true);
    };
    scriptElem.onerror = () => {
      scriptElem.remove();
    };
    scriptElem.src = this.gApiUrl;
    this.documentRef.body.appendChild(scriptElem);
  }

  // @ts-ignore
  get(): Observable<typeof google.accounts> {
    return this.onInitialized.pipe(
      first(),
      map(() => this.gsiClient!)
    );
  }
}
